export default {
  loadTypes: {
    furniture: 'اسباب کشی',
    cargo: 'بار سنگین',
    postalPostage: 'مرسوله پستی',
    delivery: 'پیک',
    pickup: 'بار شهری (وانت)',
    material: 'مصالح',
    trash: 'نخاله',
    freight: 'پیک'
  },
  pending: 'در انتظار تایید',
  accepted: 'تایید شده',
  current: 'جاری',
  completed: 'تکمیل شده',
  canceled: 'لغو شده',
  chooseCourier: 'انتخاب پروژه',
  chooseDriver: 'انتخاب راننده',
  loadType: 'نوع بار',
  templateType: 'نوع الگو',
  origin: 'مبدا',
  destination: 'مقصد',
  multiDestination: 'چند مقصدی',
  payableAmount: 'قابل پرداخت',
  cancelRequest: 'لغو درخواست',
  reOrderRegistration: 'ثبت سفارش مجدد',
  submitFeedback: 'ثبت بازخورد',
  editFeedback: 'ویرایش بازخورد',
  useTemplate: 'استفاده از الگو',
  addNewTemplate: 'افزودن الگوی جدید',
  createTemplate: 'ایجاد الگو',
  driverLiveLocation: 'موقعیت راننده',
  notPriced: 'قیمت تعیین نشده',
  generalInfo: 'اطلاعات کلی',
  loadTime: 'زمان بارگیری',
  loadTimeHour: 'ساعت بارگیری',
  dischargeTime: 'زمان تخلیه',
  estimatedTimeFromOriginToDestination: 'زمان تقریبی مبدا تا مقصد',
  distanceFromOriginToDestination: 'فاصله مبدا تا مقصد',
  driverOfferAmount: 'مبلغ پیشنهادی راننده',
  driverName: 'نام راننده',
  driverLastName: 'نام خانوادگی راننده',
  driverNationalId: 'کد ملی راننده',
  smartFleetCode: 'کد هوشمند ناوگان',
  plate: 'پلاک',
  originAndDestinationInfo: 'اطلاعات مبدا و مقصد',
  deliverer: 'تحویل دهنده',
  transferee: 'تحویل گیرنده',
  floor: 'طبقه',
  unit: 'واحد',
  distanceFromDoorToCar: 'فاصله درب تا خودرو',
  destination1: 'مقصد اول',
  destination2: 'مقصد دوم',
  destination3: 'مقصد سوم',
  destination4: 'مقصد چهارم',
  finalDestination: 'مقصد نهایی',
  trackingCodeOfCourier: 'کد رهگیری {courier}',
  orderTracking: 'رهگیری سفارش',
  carType: 'نوع خودرو',
  loaderType: 'نوع بارگیر',
  numberOfWorkers: 'تعداد کارگر',
  trajectory: 'خط سیر',
  noAllocation: 'عدم تخصیص',
  loadSpecifications: 'مشخصات بار',
  packageType: 'نوع بسته بندی',
  weight: 'وزن',
  loadMonetaryValue: 'ارزش بار',
  monetaryValue: 'ارزش',
  technicalForce: 'نیروی فنی',
  costlyItems: 'اقلام هزینه دار',
  stop: 'توقف',
  returnToOrigin: 'بازگشت به مبدا',
  postalPostageSpecifications: 'مشخصات مرسوله پستی',
  contents: 'محتویات',
  collectionTime: 'زمان جمع آوری',
  totalAmount: 'مبلغ کل',
  discount: 'تخفیف',
  templateTitle: 'عنوان الگو',
  continueOrderRegistration: 'ادامه ثبت سفارش',
  movingDate: 'تاریخ اسباب کشی',
  movingTime: 'ساعت اسباب کشی',
  loadDate: 'تاریخ بارگیری',
  dischargeDate: 'تاریخ تخلیه',
  loadTemplate: 'الگوی سفارش',
  loadDraft: 'پیش نویس بار',
  middlePoints: {
    1: 'مقصد اول',
    2: 'مقصد دوم',
    3: 'مقصد سوم',
    4: 'مقصد چهارم',
    5: 'مقصد پنجم'
  },
  completeAddress: 'تکمیل آدرس',
  freightElevator: 'آسانسور حمل بار',
  withCar: 'با خودرو',
  withoutCar: 'بدون خودرو',
  theSelectedCarWasRemoved: 'خودرو انتخابی حذف شد',
  removeSimpleEmployeeForChangeState:
    'برای تغییر نوع {orderType}، لطفا کارگر(های) حمل بار انتخاب شده را از لیست خود حذف کنید.',
  removeCarsForChangeState:
    'برای تغییر نوع {orderType}، لطفا خودرو(های) انتخاب شده را از لیست خود حذف کنید.',
  removePackagesForChangeState:
    'برای تغییر نوع {orderType}، لطفا بسته(های) انتخاب شده را از لیست خود حذف کنید.',
  timing: 'تاریخ و زمان',
  carLaborerCount: 'تعداد کارگر {carTitle} {number}',
  cargoWorker: 'کارگر حمل بار',
  intercityCarSelectionDescription:
    'کارگران حمل بار در شهر مقصد به عهده صاحب بار میباشد.',
  sortBy: 'مرتب سازی بر اساس',
  sortOptions: {
    popular: 'محبوب‌ترین',
    name: 'نام',
    cheapest: 'ارزان‌ترین',
    mostExpensive: 'گران‌ترین',
    nearest: 'نزدیک‌ترین'
  },
  distance: 'فاصله',
  courierProfile: 'پروفایل پروژه',
  offerSelectionError: {
    singleSelect: 'برای ادامه یک پروژه را انتخاب کنید',
    multiSelect: 'برای ادامه حداقل یک پروژه را انتخاب کنید'
  },
  completeInformation: 'تکمیل اطلاعات',
  saveAsDraft: 'ذخیره به عنوان پیشنویس',
  editLoadTemplate: 'ویرایش الگوی سفارش',
  submitLoadTemplate: 'ثبت الگوی سفارش',
  submitAndPay: 'ثبت و پرداخت',
  submitRequest: 'ثبت درخواست',
  createOrderWarning:
    'پس از ثبت سفارش، امکان تغییر پروژه وجود ندارد.\nاز ثبت سفارش اطمینان دارید؟',
  tariffBasedLoadSuccessDescription:
    'درخواست حمل شما با موفقیت ثبت گردید، به محض قبول درخواست توسط یکی از پروژه‌ها، پیامک تأیید برای شما ارسال می‌گردد.',
  notTariffBasedLoadSuccessDescription:
    'درخواست حمل شما با موفقیت ثبت گردید، به محض اعلام قیمت توسط هر پروژه، پیامک اطلاع رسانی برای شما ارسال می‌گردد.',
  viewSubmittedLoads: 'مشاهده سفارش‌های ثبت شده',
  submitNewLoadRequest: 'درخواست حمل جدید',
  busyCities: 'شهرهای پرتردد',
  selectPointOnMap: 'انتخاب {point} روی نقشه',
  more: 'بیشتر ...',
  rangeMessage: {
    100: 'این درخواست با تعرفه ی <b>شهری</b> محاسبه خواهد شد',
    200: 'این درخواست با قوانین و تعرفه <b>بین شهری</b> محاسبه خواهد شد'
  },
  pleaseSelectPointOnMap: 'لطفا {item} را از روی نقشه انتخاب کنید',
  loadWeight: 'وزن بار',
  typeOfShippingDocument: 'نوع سند حمل',
  postageSpecification: 'مشخصات مرسوله',
  postage: 'مرسوله',
  addPostage: 'افزودن مرسوله',
  selectCollectionTImeToContinue:
    'برای ادامه، زمان جمع آوری کالا را انتخاب کنید',
  loadId: 'شناسه سفارش',
  specification: 'مشخصات',
  newLoadTemplateCreatedSuccessfully: 'الگوی سفارش جدید با موفقیت ایجاد شد',
  areYouSureYouWantToDraftThisOrder:
    'آیا از ذخیره این سفارش به عنوان پیش نویس اطمینان دارید؟',
  draftCreatedSuccessfully: 'پیش نویس سفارش با موفقیت ایجاد شد',
  selectDriverInfo: 'انتخاب اطلاعات راننده',
  selectVehicleInfo: 'انتخاب اطلاعات خودرو',
  selectLocation: 'انتخاب محل',
  propertySelection: 'تعیین ویژگی ها',
  offerSelection: 'انتخاب پیشنهادات (پروژه)',
  overview: 'بررسی اجمالی',
  successfulSubmit: 'ثبت موفقیت آمیز',
  orderCancelReason: 'دلیل لغو سفارش',
  orderCanceledSuccessfully: 'سفارش با موفقیت لغو شد',
  courierSelectedSuccessfullyForThisOrder:
    'پروژه {courier} با موفقیت برای این سفارش انتخاب شد',
  driverSelectedSuccessfullyForThisOrder:
    'راننده {driver} با موفقیت برای این سفارش انتخاب شد',
  loadTemplateEditedSuccessfully: 'الگوی سفارش با موفقیت ویرایش شد',
  selectCity: 'انتخاب شهر',
  citySelectorDescription_html:
    'لطفا یکی از شهر های زیر را به عنوان <span class="font-bold">{title}</span> انتخاب کنید',
  submitAndNextStep: 'تایید و مرحله بعد',
  temporaryLoadSuccessMessage:
    'درخواست حمل شما با موفقیت ثبت گردید، به محض قبول درخواست توسط راننده، پیامک تأیید برای شما ارسال می‌گردد.',
  reserveOrderForLater: 'رزرو درخواست برای آینده',
  reserveDate: 'تاریخ رزرو',
  reserveTime: 'ساعت رزرو',
  doYouWantToSaveUncompletedOrderToDrafts:
    'آیا میخواهید سفارش ناتمام را در پیش نویس ذخیره کنید؟',
  orderPresubmitedInSystemAndSubmitWhenPaymentIsDone:
    'درخواست شما در بادپا ثبت و پس از پرداخت موفق در سیستم {thirdParty} ثبت می‌شود.',
  orderStatus: 'وضعیت درخواست',
  moveToMiddlePoint: 'حرکت به سمت {middlePoint}',
  paid: 'پرداخت شده',
  notPaid: 'پرداخت نشده',
  addDestination: 'افزودن مقصد',
  viewOnMap: 'مشاهده روی نقشه',
  deliveryCode: 'کد تحویل',
  dateOfCollection: 'تاریخ جمع‌آوری',
  timeOfCollection: 'ساعت جمع‌آوری',
  gatheringLocation: 'محل جمع‌آوری',
  dischargeLocation: 'محل تخلیه',
  carExcluded: 'بدون ماشین',
  insuranceExcessPercent: 'درصد افزایش بیمه',
  manualExcessPercent: 'درصد افزایش دستی',
  excelFileInfo: 'اطلاعات فایل اکسل',
  grouping: 'گروه بندی',
  groupingDescription:
    'برای گروه‌ ارسالی جدید،نوع وسیله نقلیه و  راننده انتخاب کنید. ',
  submitLoads: 'ثبت بار ها',
  loads: 'بار ها',
  allLoadDatesInGroupShouldBeInSameDay:
    'تاریخ بارگیری همه آیتم های گروه باید در یک روز باشند!',
  allLoadTypesInGroupShouldBeTheSame:
    'نوع بار همه آیتم های گروه باید یکسان باشد!',
  allPackageTypesInGroupShouldBeTheSame:
    'نوع بسته‌بندی همه آیتم های گروه باید یکسان باشد!',
  dischargeStartTime: 'زمان شروع تخلیه',
  dischargeEndTime: 'زمان پایان تخلیه',
  dischargeEndTimeShouldBeAtLeastOneHourAfterStartTime:
    'زمان پایان تخلیه باید حداقل یک ساعت بعد از زمان شروع تخلیه باشد!',
  loadingStartTime: 'زمان شروع بارگیری',
  loadingEndTime: 'زمان پایان بارگیری',
  addon: 'خدمات جانبی',
  batchId: 'شناسه دسته',
  destinations: {
    1: 'مقصد اول',
    2: 'مقصد دوم',
    3: 'مقصد سوم',
    4: 'مقصد چهارم',
    5: 'مقصد پنجم',
    6: 'مقصد ششم',
    7: 'مقصد هفتم',
    8: 'مقصد هشتم',
    9: 'مقصد نهم',
    10: 'مقصد دهم',
    11: 'مقصد یازدهم',
    12: 'مقصد دوازدهم',
    13: 'مقصد سیزدهم',
    14: 'مقصد چهاردهم',
    15: 'مقصد پانزدهم',
    16: 'مقصد شانزدهم',
    17: 'مقصد هفدهم',
    18: 'مقصد هجدهم',
    19: 'مقصد نوزدهم',
    20: 'مقصد بیستم',
    21: 'مقصد بیست و یکم',
    22: 'مقصد بیست و دوم',
    23: 'مقصد بیست و سوم',
    24: 'مقصد بیست و چهارم',
    25: 'مقصد بیست و پنجم',
    26: 'مقصد بیست و ششم',
    27: 'مقصد بیست و هفتم',
    28: 'مقصد بیست و هشتم',
    29: 'مقصد بیست و نهم',
    30: 'مقصد سی‌ام',
    31: 'مقصد سی و یکم',
    32: 'مقصد سی و دوم',
    33: 'مقصد سی و سوم',
    34: 'مقصد سی و چهارم',
    35: 'مقصد سی و پنجم',
    36: 'مقصد سی و ششم',
    37: 'مقصد سی و هفتم',
    38: 'مقصد سی و هشتم',
    39: 'مقصد سی و نهم',
    40: 'مقصد چهلم',
    41: 'مقصد چهل و یکم',
    42: 'مقصد چهل و دوم',
    43: 'مقصد چهل و سوم',
    44: 'مقصد چهل و چهارم',
    45: 'مقصد چهل و پنجم',
    46: 'مقصد چهل و ششم',
    47: 'مقصد چهل و هفتم',
    48: 'مقصد چهل و هشتم',
    49: 'مقصد چهل و نهم',
    50: 'مقصد پنجاهم',
    51: 'مقصد پنجاه و یکم',
    52: 'مقصد پنجاه و دوم',
    53: 'مقصد پنجاه و سوم',
    54: 'مقصد پنجاه و چهارم',
    55: 'مقصد پنجاه و پنجم',
    56: 'مقصد پنجاه و ششم',
    57: 'مقصد پنجاه و هفتم',
    58: 'مقصد پنجاه و هشتم',
    59: 'مقصد پنجاه و نهم',
    60: 'مقصد شصتم',
    61: 'مقصد شصت و یکم',
    62: 'مقصد شصت و دوم',
    63: 'مقصد شصت و سوم',
    64: 'مقصد شصت و چهارم',
    65: 'مقصد شصت و پنجم',
    66: 'مقصد شصت و ششم',
    67: 'مقصد شصت و هفتم',
    68: 'مقصد شصت و هشتم',
    69: 'مقصد شصت و نهم',
    70: 'مقصد هفتادم',
    71: 'مقصد هفتاد و یکم',
    72: 'مقصد هفتاد و دوم',
    73: 'مقصد هفتاد و سوم',
    74: 'مقصد هفتاد و چهارم',
    75: 'مقصد هفتاد و پنجم',
    76: 'مقصد هفتاد و ششم',
    77: 'مقصد هفتاد و هفتم',
    78: 'مقصد هفتاد و هشتم',
    79: 'مقصد هفتاد و نهم',
    80: 'مقصد هشتادم',
    81: 'مقصد هشتاد و یکم',
    82: 'مقصد هشتاد و دوم',
    83: 'مقصد هشتاد و سوم',
    84: 'مقصد هشتاد و چهارم',
    85: 'مقصد هشتاد و پنجم',
    86: 'مقصد هشتاد و ششم',
    87: 'مقصد هشتاد و هفتم',
    88: 'مقصد هشتاد و هشتم',
    89: 'مقصد هشتاد و نهم',
    90: 'مقصد نودم',
    91: 'مقصد نود و یکم',
    92: 'مقصد نود و دوم',
    93: 'مقصد نود و سوم',
    94: 'مقصد نود و چهارم',
    95: 'مقصد نود و پنجم',
    96: 'مقصد نود و ششم',
    97: 'مقصد نود و هفتم',
    98: 'مقصد نود و هشتم',
    99: 'مقصد نود و نهم',
    100: 'مقصد صدم'
  },

  licenseIsRequired: 'مجوز نیاز است',
  licenses: 'مجوز ها',
  IWantInsurance: 'بیمه می‌خواهم',
  fromStartToEnd: 'از ساعت {start} تا ساعت {end}',
  nameOfThePayee: 'نام متولی پرداخت'
}
